import { render, staticRenderFns } from "./FeatForm.vue?vue&type=template&id=272774d0&scoped=true&"
import script from "./FeatForm.vue?vue&type=script&lang=js&"
export * from "./FeatForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "272774d0",
  null
  
)

export default component.exports